import React, { useEffect, useMemo, useReducer, useRef, useContext, useState } from 'react'

import './PhotoViewerRotate.css'
import { Button, Carousel, message } from 'antd'
import { ACCEPT, DECLINE, UNKNOWN_DOC } from '../../../../Constants'
import { profileScreen } from '../../../../translates'
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  MinusOutlined,
  PlusOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  ColumnWidthOutlined
} from '@ant-design/icons'
import { makeFileUrl, simpleReducer, dragElement } from '../../../../helper'
import { adminReducerActions, AppConfig } from '../../../../AppConfig'
import PdfViewer from '../PhotoViewer/PdfViewer'
// import Approval from '../../Approval/Approval'
import { ConfigContext } from '../../../../context/configContext'
import { useMutateAdminUpdatePartnerDocs } from '../../../../api/react-query/adminPartners'
import { useGetPartnerId } from '../../../../hooks/useGetPartnerId'
import ApprovalAction from '../../Approval/ApprovalAction'

const iconStyle = { fontSize: '40px' }
const buttonStyle = { height: '64px' }
const idImgDoc = 'idImgDoc'

const initialState = {
  scale: 1,
  rotate: 0
}

const ROTATE_DEGREE = 90

const getActualAngle = totalAngle => {
  const clearAngle = totalAngle % 360
  return Math.abs(clearAngle < 0 ? 360 + clearAngle : clearAngle)
}
const DEFAULT_DOCUMENT_PARAMS = {
  rotate: 0,
  isFlipped: false
}
function PhotoViewerRotate ({
  componentName = null,
  documents,
  onCommitDocument = () => {},
  loading = false,
  disableApproval = false
}) {
  const id = useGetPartnerId()
  const { setConfig, partnerData } = useContext(ConfigContext)
  const { profile } = partnerData
  const [state, setState] = useReducer(simpleReducer, initialState)
  // нужен мап параметров тк если использовать одного стейта на все при пролистывании и старый и новый меняют состояние что выглядит плохо
  const [documentsParams, setDocumentsParams] = useState(() => {
    return documents.reduce((acc, key) => {
      acc[key] = DEFAULT_DOCUMENT_PARAMS
      return acc
    }, {})
  })
  const slider = useRef(null)
  const { isAdmin, isCoordinators, isCoordinator } =
    useContext(ConfigContext)

  const { isLoading: isLoadingAdminUpdatePartnerDocs, mutateAsync: mutateAdminUpdatePartnerDocs } =
    useMutateAdminUpdatePartnerDocs()

  const componentPrefix = useMemo(() => componentName ?? '', [componentName])

  const handleClickMinus = () => {
    setState({ scale: state.scale - 1 > 0 ? state.scale - 1 : state.scale })
  }
  const handleClickPlus = () => {
    setState({ scale: state.scale + 1 })
  }

  const handleClickPrev = () => {
    setState(initialState)
    slider?.current?.prev()
  }
  const handleClickNext = () => {
    setState(initialState)
    slider?.current?.next()
  }

  const updateDocumentDegrees = (documentName, degrees) => {
    setDocumentsParams(prev => {
      return {
        ...prev,
        [documentName]: {
          ...prev[documentName],
          rotate: getActualAngle(prev[documentName].rotate + degrees)
        }
      }
    })
  }

  const changeImageFlipped = imageName => {
    setDocumentsParams(prev => {
      return {
        ...prev,
        [imageName]: {
          ...prev[imageName],
          isFlipped: !prev[imageName].isFlipped
        }
      }
    })
  }

  useEffect(() => {
    documents
      .filter(d => profile?.[d]?.fileId)
      .forEach(d => {
        const list = document.getElementsByClassName(`${componentPrefix}${idImgDoc}${d}`)
        Array.prototype.forEach.call(list, imageDoc => {
          if (imageDoc) {
            dragElement(imageDoc)
          }
        })
      })
  }, [])

  const handleCommit = (d, o, c) => onCommitDocument(d, o, c, () => slider?.current?.next())
  const handleSave = async (documentType, angle, flip) => {
    const result = await mutateAdminUpdatePartnerDocs({
      id,
      outcome: 'edit',
      body: {
        documentType,
        angle,
        ...(flip && { flip })
      }
    })

    if (result.isSuccess) {
      setConfig({ type: adminReducerActions.updatePartner, value: result.partner })
      setDocumentsParams(prev => {
        return {
          ...prev,
          [documentType]: DEFAULT_DOCUMENT_PARAMS
        }
      })
    } else {
      message.error('Изображение не обновлено')
    }
  }

  return (
    <div className='photo-viewer-rotate'>
      <Carousel ref={slider} dots={null}>
        {documents
          .filter(d => profile?.[d]?.fileId)
          .map(d => (
            <div key={d}>
              <h2>{profileScreen.input[d]?.label ?? UNKNOWN_DOC}</h2>
              <div className='toolbar'>
                {(isAdmin || isCoordinators || isCoordinator) && (
                  <Button
                    disabled={Boolean(
                      documentsParams[d].rotate === initialState.rotate &&
                        !documentsParams[d].isFlipped
                    )}
                    onClick={() =>
                      handleSave(d, documentsParams[d].rotate, documentsParams[d].isFlipped)}
                    loading={isLoadingAdminUpdatePartnerDocs}
                  >
                    Сохранить
                  </Button>
                )}
                <Button icon={<MinusOutlined />} className='ml-3' onClick={handleClickMinus} />
                <Button icon={<PlusOutlined />} className='ml-3' onClick={handleClickPlus} />
                <Button
                  className='ml-3'
                  icon={<RotateLeftOutlined />}
                  onClick={() => updateDocumentDegrees(d, -ROTATE_DEGREE)}
                />
                <Button
                  className='ml-3'
                  icon={<RotateRightOutlined />}
                  onClick={() => updateDocumentDegrees(d, ROTATE_DEGREE)}
                />
                <Button
                  className='ml-3'
                  icon={<ColumnWidthOutlined />}
                  onClick={() => changeImageFlipped(d)}
                />
              </div>
              <div className='image-wrap'>
                {profile?.[d]?.fileType === AppConfig.uploadTypes.pdf ? (
                  <PdfViewer fileId={profile?.[d]?.fileId} zoom={state.scale} />
                ) : (
                  <div>
                    <img
                      className={`${componentPrefix}${idImgDoc}${d}`}
                      src={makeFileUrl(profile?.[d]?.fileId)}
                      style={{
                        transform: `
                          scaleX(${documentsParams[d].isFlipped ? '-' : ''}${state.scale}) 
                          scaleY(${state.scale}) 
                          rotate(${documentsParams[d].rotate}deg)
                          `
                      }}
                    />
                  </div>
                )}
              </div>
              <div>
                <Button style={buttonStyle} onClick={handleClickPrev} type='link'>
                  <ArrowLeftOutlined style={iconStyle} />
                </Button>
                <Button style={buttonStyle} onClick={handleClickNext} type='link'>
                  <ArrowRightOutlined style={iconStyle} />
                </Button>
              </div>
              {profile?.[d]?.allowReview && !disableApproval && (
                <div style={{ paddingRight: '0.5rem' }}>
                  <ApprovalAction
                    targetType={d}
                    disabled={false}
                    defaultComment={profile?.[d]?.statusReason}
                    defaultOutcome={profile?.[d]?.status}
                    onAccept={() => handleCommit(d, ACCEPT)}
                    onDecline={(comment) => handleCommit(d, DECLINE, comment)}
                  />
                </div>
              )}
            </div>
          ))}
      </Carousel>
    </div>
  )
}

export default PhotoViewerRotate
